import classNames from "classnames";
import styles from "./style.module.scss";

interface InputProps extends React.HTMLProps<HTMLTextAreaElement> {
  label?: string;
  required?: boolean;
  error?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  customLabelStyle?: string;
  customInputStyle?: string;
  customInputContainer?: string;
  limit?: number;
  showLimit?: boolean;
  disabled?: boolean;
}

const CustomTextArea = ({
  label,
  required = false,
  error = "",
  value = "",
  placeholder,
  onChange,
  onBlur,
  customLabelStyle,
  customInputStyle,
  customInputContainer,
  limit = 3000,
  showLimit = false,
  disabled = false,
}: Partial<InputProps>) => {
  const id = label ? label.replace(/\s+/g, "-").toLowerCase() : undefined;
  const remainingChars = limit - (value?.toString().length || 0);

  return (
    <div className="relative mb-3 w-full">
      <div className="flex flex-col items-start w-full gap-2">
        {label && (
          <h6
            className={classNames(
              styles.inputLabel,
              customLabelStyle && customLabelStyle,
            )}
          >
            {label} {required && <span className={styles.asterik}>*</span>}
          </h6>
        )}
        <div
          className={classNames(
            styles.inputContainer,
            customInputContainer,
            { [styles.disabled]: disabled },
            !!error && styles.inputContainerError,
            "w-full",
          )}
        >
          <textarea
            id={id}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            className={classNames(
              styles.inputStyle,
              "h-full",
              customInputStyle,
            )}
            value={value}
            disabled={disabled}
          />
        </div>
      </div>
      {error ? (
        <span className={styles.error} role="alert" aria-live="polite">
          {error}
        </span>
      ) : (
        showLimit && (
          <label className={styles.lmtLabel}>
            {remainingChars} characters left
          </label>
        )
      )}
    </div>
  );
};

export default CustomTextArea;
